export default __webpack_public_path__ + "static/media/warning-bot.a7eb495b.svg";